import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export type ConfirmDialogConfig = {
  title?: string;
  message?: string;
  confirm?: string;
  cancel?: string;
};

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
  standalone: false
})
export class ConfirmDialogComponent {
  private static DEFAULT_CONFIG = {
    title: "confirmationDialog.title",
    message: "confirmationDialog.message",
    confirm: "confirmationDialog.confirm",
    cancel: "confirmationDialog.cancel"
  };

  static DEFAULT_WINDOW_SIZE = {
    width: "500px",
    height: "250px"
  };

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogConfig
  ) {
    this.data = {
      ...ConfirmDialogComponent.DEFAULT_CONFIG,
      ...data
    };
  }
}
